import { sx } from '../../../lib/sx'
import type { Vals } from '../../../demo/vals'

export function ThreatBlocked({ v }: { v: Vals }) {
  return (
    <div style={sx("position:absolute;inset:0;padding:64px 20px 34px;display:flex;flex-direction:column;background:radial-gradient(120% 55% at 50% 8%,var(--color-red-900) 0%,var(--bg-primary) 60%)")}>
      <div style={sx("flex:1;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:18px;text-align:center")}>
        <span style={sx("width:96px;height:96px;border-radius:var(--radius-full);background:var(--bg-critical);display:flex;align-items:center;justify-content:center;animation:gring 1.6s var(--ease-out) 2")}>
          {v.blockedIsCall ? (
            <>
              <span style={sx("width:42px;height:42px;background:#fff;-webkit-mask:url(/assets/icons/spam-call.svg) center/contain no-repeat;mask:url(/assets/icons/spam-call.svg) center/contain no-repeat")} />
            </>
          ) : null}
          {v.blockedIsSite ? (
            <>
              <span style={sx("width:42px;height:42px;background:#fff;-webkit-mask:url(/assets/icons/malicious-site.svg) center/contain no-repeat;mask:url(/assets/icons/malicious-site.svg) center/contain no-repeat")} />
            </>
          ) : null}
        </span>
        <span style={sx("font-size:var(--fs-6xl);font-weight:var(--fw-bold);letter-spacing:var(--ls-sm);line-height:38px")}>
          {v.blockedTitle}
        </span>
        <span style={sx("font-size:var(--fs-md);line-height:22px;color:var(--text-secondary);max-width:290px")}>
          {v.blockedBody}
        </span>
        <span style={sx("padding:10px 14px;border-radius:var(--radius-md);background:var(--bg-secondary);border:1px solid var(--border-secondary);font-size:var(--fs-sm);font-weight:var(--fw-medium)")}>
          {v.blockedSubject}
        </span>
        {/* Always shown. "Nobody else was told" is the reassurance a member
            most wants when they have not opted in — hiding it left the one
            state that needed saying unsaid. */}
        <span style={sx("display:flex;gap:8px;align-items:center;padding:10px 14px;border-radius:var(--radius-full);background:var(--bg-tertiary)")}>
          <span style={sx("width:16px;height:16px;background:var(--text-secondary);-webkit-mask:url(/assets/icons/bell.svg) center/contain no-repeat;mask:url(/assets/icons/bell.svg) center/contain no-repeat")} />
          <span style={sx("font-size:var(--fs-xs);color:var(--text-secondary)")}>
            {v.blockedShareNote}
          </span>
        </span>
      </div>
      <div style={sx("display:flex;flex-direction:column;gap:8px")}>
        <button onClick={v.dismissBlocked} style={sx("height:52px;border-radius:var(--radius-full);border:none;background:var(--bg-accent);color:#fff;font-family:inherit;font-size:var(--fs-md);font-weight:var(--fw-medium);cursor:pointer")}>
          Got it
        </button>
        <button onClick={v.dismissBlocked} style={sx("height:44px;border-radius:var(--radius-full);border:none;background:transparent;color:var(--text-secondary);font-family:inherit;font-size:var(--fs-sm);cursor:pointer")}>
          {v.blockedSecondary}
        </button>
      </div>
    </div>
  )
}
